// Agreement is now shown every time - no localStorage persistence
export const hasAcceptedAgreement = (): boolean => {
  // Always return false to show agreement modal every time
  return false;
};

export const acceptAgreement = (): void => {
  // No longer saves to localStorage
  // Agreement must be accepted each session
};

export const clearAgreement = (): void => {
  // No localStorage to clear
  // Keeping function for backward compatibility
};
